import React from "react";

export default function AboutSection() {
  return (
    <section className="bg-white border rounded-xl p-6 shadow-sm">
      <h3 className="text-xl font-bold mb-2">About Equip Foundation</h3>

      <p className="text-gray-700 leading-relaxed">
        Equip Foundation exists to equip believers and communities through
        discipleship, teaching, mentorship, and practical support. Our heart is
        to see people grow in Christ, build strong foundations of faith, and
        live out the Gospel in everyday life.
      </p>

      <div className="mt-4 grid gap-3 sm:grid-cols-3">
        <div className="p-4 rounded-lg bg-indigo-50 border">
          <div className="font-semibold text-indigo-900">Discipleship</div>
          <div className="text-sm text-indigo-800">
            Helping believers mature and walk in purpose.
          </div>
        </div>

        <div className="p-4 rounded-lg bg-indigo-50 border">
          <div className="font-semibold text-indigo-900">Teaching</div>
          <div className="text-sm text-indigo-800">
            Bible-based training that builds strong foundations.
          </div>
        </div>

        <div className="p-4 rounded-lg bg-indigo-50 border">
          <div className="font-semibold text-indigo-900">Community Impact</div>
          <div className="text-sm text-indigo-800">
            Serving with compassion and practical support.
          </div>
        </div>
      </div>
    </section>
  );
}